import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref, watch } from 'vue';
import { XlsxRead, XlsxJson } from 'vue3-xlsx';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FilePreviewXlsx' },
  __name: 'FilePreviewXlsx',
  props: {
    file: {}
  },
  setup(__props: any) {

const props = __props;


const cachedFile = ref<File>(props.file);

watch(
  () => props.file,
  (newFile) => {
    cachedFile.value = newFile;
  }
);

// Оставлю пока здесь, надо посмотреть в каком виде люди загружают файлы,
// так как библиотека умеет генерировать заголовки только из первой строки в экселе,
// иначе все плохо и надо генерить заголовки как то самим

// const columns = ref<QuasarTableColumnList>([])

// const xlsxParser = (data) => {
//   columns.value = [];
//   if(data){
//     let keysArray = Object.entries(data[0]).map(([key]) => key);
//     keysArray.forEach(elem => {
//       let countNumber = ref(0);
//       columns.value.push({
//         name: elem,
//         field: elem,
//         label: countNumber.value.toString(),
//       },)
//     });
//     return data
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_unref(XlsxRead), { file: cachedFile.value }, {
    default: _withCtx(() => [
      _createVNode(_unref(XlsxJson), null, {
        default: _withCtx(({ collection }) => [
          collection
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 0,
                class: "s-table",
                rows: collection
              }, null, 8, ["rows"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["file"]))
}
}

})